import { useEffect, useRef } from "react";

const useClickOutside = (handler) => {
    const domNode = useRef();

    useEffect(() => {
        const action = (event) => {
            if (!domNode.current?.contains(event.target)) {
                handler();
            }
        };

        document.addEventListener("mousedown", action);

        return () => {
            document.removeEventListener("mousedown", action);
        };
    }, []);
    return domNode;
};

export default useClickOutside;
